const STORAGE_PREFIX = "noga-purchase:v1:";
const claimedOrderIds = new Set<string>();

export function claimPurchaseTracking(orderId?: string | null) {
  if (typeof window === "undefined" || !orderId) {
    return false;
  }

  if (claimedOrderIds.has(orderId)) {
    return false;
  }

  const key = `${STORAGE_PREFIX}${orderId}`;

  try {
    if (sessionStorage.getItem(key)) {
      claimedOrderIds.add(orderId);
      return false;
    }
    sessionStorage.setItem(key, "1");
    claimedOrderIds.add(orderId);
    return true;
  } catch {
    claimedOrderIds.add(orderId);
    return true;
  }
}
